/**
 * Catálogo padrão de COMPETÊNCIAS (skills) do colaborador.
 *
 * É a lista de marcação do cadastro e a referência do espelhamento: o RH/DP é
 * dono das competências DESTA lista, e elas descem para os departamentos junto
 * com o resto do cadastro. Competências fora da lista (ex.: o título de um
 * treinamento que a IA gravou num departamento) são LOCAIS e nunca são
 * apagadas pela sincronização.
 *
 * Arquivo sem nenhum import de propósito: é usado tanto pela tela (config.ts)
 * quanto pelo servidor (espelho/fonte). Para incluir ou remover uma
 * competência, edite ESTA lista — e a mesma nos outros sistemas do portal.
 */
export const SKILLS_CATALOGO: string[] = [
  "Ensaio elétrico",
  "Tratamento termovácuo",
  "Troca de óleo",
  "Montagem de transformadores",
  "Desmontagem de transformador",
  "Instalação de transformador (Caminhão Munck)",
  "Instalação de transformador (Mão de obra)",
  "Eliminação de vazamento em transformador",
  "Eliminação de vazamento em TC",
  "Eliminação de vazamento em TP",
  "Manutenção preventiva em subestação até 138 KV",
  "Manutenção preventiva em subestação até 230 KV",
  "Manutenção preventiva em subestação até 500 KV",
  "Reforma de transformador em oficina",
  "Reforma de disjuntor em oficina",
  "Reforma de equipamentos em oficina",
];

/** Compara competências ignorando acento e caixa (evita duplicar a mesma). */
export function normSkill(s: unknown): string {
  return String(s ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

/** Quebra o texto gravado em itens (aceita vírgula, ponto-e-vírgula e quebra de linha). */
export function parseSkills(texto: unknown): string[] {
  return String(texto ?? "")
    .split(/[,;\n]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

const CATALOGO_NORM = new Set(SKILLS_CATALOGO.map(normSkill));

/** A competência faz parte do catálogo padrão (logo, é mantida pelo RH/DP)? */
export function doCatalogo(skill: string): boolean {
  return CATALOGO_NORM.has(normSkill(skill));
}

/**
 * O colaborador é do OPERACIONAL?
 *
 * As competências desta lista são todas de campo (ensaio, montagem, termovácuo,
 * subestação…): só fazem sentido para quem trabalha na operação. Por isso o
 * quadro de marcação só aparece para essas pessoas — no RH o campo nem é
 * exibido para o administrativo (RH, DP, Comercial, Qualidade…).
 *
 * O nome vem do `departamento` do cadastro do RH — que é preenchido pela tabela
 * de Cargos e Salários ("Operacional") — ou do `setor` espelhado aqui
 * ("Operações", "Gestão da Operação"). Todos têm o mesmo radical, então a
 * comparação é por "operac" (sem acento e sem caixa).
 */
export function ehDoOperacional(departamento: unknown): boolean {
  return normSkill(departamento).includes("operac");
}
